import useStableCallback from 'src/hooks/useCallbackUtils/useStableCallback';
import { ebGlobalChannel } from 'src/lib/events-bridge';
import useSubscription from 'src/lib/events-bridge/hooks/useSubscription';
import EBAPIs from 'src/lib/events-bridge/topics';
import useDocumentPicker from './useDocumentPicker';
const useFilePicker = () => {
    const documentPicker = useDocumentPicker();
    const pick = useStableCallback(async (options) => {
        return documentPicker.pick(options);
    });
    useSubscription(EBAPIs.helperViews.filePicker.pick, (options) => {
        return pick(options);
    });
    return { pick };
};
export const filePickerHelperViewActions = {
    pick(options) {
        return ebGlobalChannel.request(EBAPIs.helperViews.filePicker.pick, options);
    },
};
export default useFilePicker;
